import GenericHttpService from "./GenericHttpService";
import { montarMetadadosDominioGeral } from "./dominioListaMetadata";

import http from "../utils/HttpCommon";

export const dominio = {
  tipoDocumento: "TIPO_DOCUMENTO",
  tipoAnalise: "TIPO_ANALISE",
  tipoVerificacaoCondicao: "TIPO_VERIFICACAO_CONDICAO",
  tipoVerificacaoLimite: "TIPO_VERIFICACAO_LIMITE",
  status: "STATUS",
  tipoVinculativoNormativo: "TIPO_VINCULO_NORMATIVO",
  abrangenciaEsferas: "TIPO_ABRANGENCIA_ESFERAS",
  tipoPrograma: "TIPO_PROGRAMA",
  tipoOperacaoTipoAnalise: "TIPO_OPERACAO_TPANALISE",
  especiePvlTipoAnalise: "ESPECIEPVL_TPANALISE",
  emissorDebentureTipoAnalise: "DEBENT_EMISSOR_TPANALISE",
  instituicaoDebentureTipoAnalise: "DEBENT_INSTLIDER_TPANALISE",
  emissorTitulosPublicosTipoAnalise: "TITPUB_EMISSOR_TPANALISE",
  instituicaoTitulosPublicosTipoAnalise: "TITPUB_INSTLIDER_TPANALISE",
  tomadoresTipoAnalise: "TOMADORES_TPANALISE",
  credoresTipoAnalise: "CREDORES_TPANALISE",
  garantidoresTipoAnalise: "GARANTIDORES_TPANALISE",
  angentesFinanceirosTipoAnalise: "AGFINANCEIRO_TPANALISE",
  tipoAssuntoDemandaJudicial: "TIPO_ASSUNTO_DEMANDA_JUDICIAL",
  tipoObjeto: "TIPO_OBJETO_VERIFICACAO",
};

export const entidade = {
  autoridade: "autoridade-emitente",
  normativo: "normativos",
  normativo2: "normativos2",
  dispositivosNormativo: "dispositivos-normativo",
  finalidade: "finalidades",
  programa: "programas",
  limite: "limites",
};

export const LISTAS_AUTORIDADEEMITENTE = "LISTA_AUTEMIT";
export const LISTAS_TIPODOC = "LISTA_TIPDOC";

export const DOMINIO_LOGICO = [
  { codigo: "true", nome: "Sim" },
  { codigo: "false", nome: "Não" },
];
export const DOMINIO_STATUS2 = [
  { codigo: "AT", nome: "Ativo" },
  { codigo: "IN", nome: "Inativo" },
];
export const DOMINIO_TIPO_FONTE = "TIPO_FONTE";
export const DOMINIO_DOCUMENTO_NIVEL_ACESSO = "NIVEL_ACESSO_DOCUMENTO_UPLOAD";
export const DOMINIO_TIPODOCUMENTO = "TIPO_DOCUMENTO";
export const DOMINIO_TIPOANALISE = "TIPO_ANALISE";
export const DOMINIO_TIPOVERIFICACAOCONDICAO = "TIPO_VERIFICACAO_CONDICAO";
export const DOMINIO_TIPOVERIFICACAOLIMITE = "TIPO_VERIFICACAO_LIMITE";
export const DOMINIO_STATUS = "STATUS";
export const DOMINIO_TIPOVINCULONORMATIVO = "TIPO_VINCULO_NORMATIVO";
export const DOMINIO_ABRANGENCIA_ESFERAS = "TIPO_ABRANGENCIA_ESFERAS";
export const DOMINIO_ESFERA = "ESFERA";
export const DOMINIO_TIPOPROGRAMA = "TIPO_PROGRAMA";
export const DOMINIO_ASSUNTO_DEMANDA_JUDICIAL = "TIPO_ASSUNTO_DEMANDA_JUDICIAL";
export const DOMINIO_TIPOPERIODICIDADE_PARAMETRO_CALCULO =
  "TIPO_PERIODICIDADE_PARAMETRO_CALCULO";
export const DOMINIO_TIPODADO_PARAMETRO_CALCULO = "TIPO_DADO_PARAMETRO_CALCULO";
export const DOMINIO_TIPOENTRADA_PARAMETRO_CALCULO =
  "TIPO_ENTRADA_PARAMETRO_CALCULO";
export const DOMINIO_TIPOMES = "TIPO_MES";

export const DOMINIO_TIPOOPERACAO_TPANALISE = "TIPO_OPERACAO_TPANALISE";
export const DOMINIO_ESPECIEPVL_TPANALISE = "ESPECIEPVL_TPANALISE";
export const DOMINIO_EMISSOR_DEBENTURE_TPANALISE = "DEBENT_EMISSOR_TPANALISE";
export const DOMINIO_INST_DEBENTURE_TPANALISE = "DEBENT_INSTLIDER_TPANALISE";
export const DOMINIO_EMISSOR_TITULOS_PUBLICOS_TPANALISE =
  "TITPUB_EMISSOR_TPANALISE";
export const DOMINIO_INST_TITULOS_PUBLICOS_TPANALISE =
  "TITPUB_INSTLIDER_TPANALISE";

export const DOMINIO_TOMADORES_TPANALISE = "TOMADORES_TPANALISE";
export const DOMINIO_CREDORES_TPANALISE = "CREDORES_TPANALISE";
export const DOMINIO_GARANTIDORES_TPANALISE = "GARANTIDORES_TPANALISE";
export const DOMINIO_AG_FINANCEIROS_TPANALISE = "AGFINANCEIRO_TPANALISE";

export const DOMINIO_TIPODIRECAO_QUADRO = "TIPO_DIRECAO_QUADRO";
export const DOMINIO_TIPOREGISTRO_QUADRO = "TIPO_REGISTRO_QUADRO";
export const DOMINIO_TIPO_MASCARA = "TIPO_MASCARA";

export const DOMINIO_TIPO_DIVIDA = "TIPO_DIVIDA";
export const DOMINIO_ESPECIE_PVL = "ESPECIE_PVL";
export const DOMINIO_TIPO_DEVEDOR = "COC_TIPO_DEVEDOR";
export const DOMINIO_TIPO_ENTE = "TIPO_ENTE";
export const DOMINIO_TIPO_ENTIDADE = "TIPO_ENTIDADE";
export const TIPO_ENTIDADE_ENTE_FEDERATIVO = "TIPO_ENTIDADE_ENTE_FEDERATIVO";
export const TIPO_ENTIDADE_CONSORCIO_PUBLICO = "TIPO_ENTIDADE_CONSORCIO_PUBLICO";
export const TIPO_ENTIDADE_EMPRESARIAL = "TIPO_ENTIDADE_EMPRESARIAL"
export const ID_TIPO_ENTIDADE_ENTE_FEDERATIVO = 600;
export const ID_TIPO_ENTIDADE_CONSORCIO_PUBLICO = 601;
export const ID_TIPO_ENTIDADE_EMPRESARIAL = 602;
export const DOMINIO_TIPO_ABRANGENCIA = "TIPO_ABRANGENCIA";
export const DOMINIO_TIPO_PESSOA = "TIPO_PESSOA";
export const DOMINIO_ORIGEM_ENTIDADE = "ORIGEM_ENTIDADE";
export const DOMINIO_NATUREZA = "NATUREZA_CREDOR_DEVEDOR";
export const DOMINIO_NATUREZA_JURIDICA = "NATUREZA_JURIDICA";
export const MODO_INCLUSAO_AUTOCADASTRAMENTO = "MODO_INCLUSAO_AUTOCADASTRAMENTO";
export const DOMINIO_MODO_INCLUSAO_USUARIO = "MODO_INCLUSAO_USUARIO";
export const DELEGACAO_DELEGANTE = "DELEGANTE";
export const DELEGACAO_DELEGADO = "DELEGADO";
export const DELEGACAO_NAO_PARTICIPA = "NAO_PARTICIPA";
export const DOMINIO_DELEGACAO_COMPETENCIA = "DELEGACAO_COMPETENCIA";
export const DOMINIO_TIPO_MOEDA = "TIPO_MOEDAS";
export const DOMINIO_PVL_SITUACAO = "PVL_SITUACAO";
export const DOMINIO_ITEM_VERIFICACAO_PVL_SITUACAO = "ITEM_VERIFICACAO_PVL_SITUACAO";
export const DOMINIO_COC_SITUACAO = "COC_SITUACAO";
export const DOMINIO_ORIGEM_DOCUMENTO = "ORIGEM_DOCUMENTO";
export const DOMINIO_TIPO_OBJETO = "TIPO_OBJETO_VERIFICACAO";
export const DOMINIO_TIPOOBJETO_CALCULO = 'CALCULO';
export const DOMINIO_TIPOOBJETO_DOCUMENTO = 'DOCUMENTO';
export const DOMINIO_SISTEMA_ORIGEM = "SISTEMA_ORIGEM";
export const DOMINIO_TIPO_VINCULO_RELACIONAMENTO_NORMATIVO = "TIPO_VINCULO_RELACIONAMENTO_NORMATIVO";
export const DOMINIO_PREFERENCIA_TELA_INICIAL = "PREFERENCIA_TELA_INICIAL";
export const ENTIDADE_AUTORIDADE = "autoridade-emitente";
export const ENTIDADE_NORMATIVO = "normativos";
export const ENTIDADE_NORMATIVO2 = "normativos2";
export const ENTIDADE_DISPOSITIVOS_NORMATIVO = "dispositivos-normativo";
export const ENTIDADE_FINALIDADE = "finalidades";
export const ENTIDADE_PROGRAMA = "programas";
export const ENTIDADE_LIMITE = "limites";
export const ENTIDADE_CONDICAO = "condicoes";
export const ENTIDADE_CONDICAO_DETALHES = "condicao-detalhes";
export const ENTIDADE_PARAMETRO_CALCULO = "parametros-calculo";

export const ENTIDADE_CAUC_EXTRATO = "cauc-extratos";
export const ENTIDADE_CAUC_ITENS = "cauc-itens";

export const ENTIDADE_QUADROANALISE_CONTEXTOS = "contextos";
export const ENTIDADE_QUADROANALISE_FUNCOES = "funcoes";
//export const ENTIDADE_QUADRO_ANALISE = 'modelo-quadro-analise';
export const ENTIDADE_QUADROANALISE = "modelos-quadro-analise";
export const ENTIDADE_QUADROANALISECAMPOS = "modelos-quadro-analise-campos";
//export const ENTIDADE_QUADROCAMPO = 'modelos-quadro-campo';

export const ENTIDADE_ENTE = "ente-ibge";
export const ENTIDADE_ENTE_UFS = "listar-ufs";
export const ENTIDADE_PESSOA_JURIDICA = "pessoa-juridica";
export const ENTIDADE_PESSOA_FISICA = "pessoa-fisica";
export const ENTIDADE_LISTA_VERIFICACAO = "listas-verificacao";

export const ENTIDADE_ITEM_VERIFICACAO = 'item-verificacao';
export const ENTIDADE_SUBITEM_VERIFICACAO = 'subitem-verificacao';
export const ENTIDADE_CALCULOS = 'calculos';
export const ENTIDADE_TIPO_DOCUMENTOS = 'tipo-documentos-pvl';

export const OBJETO_VERIFICACAO = "objeto-verificacao";
export const OBJETO_VINCULADO = "objeto-vinculado";
export const ENTIDADE_SITUACOES_PLEITO_SADIPEM = "situacoes-pleito-sadipem";
export const CALCULOS = "calculos";

export const ENTIDADE_ENTIDADE = "entidade";
export const ENTIDADE_PERFIL = "perfil";

export const TIPO_DOCUMENTO_ANALISE = "tipo-documento-analise";

export const FUNCIONALIDADE = "funcionalidade";

export const USUARIO_POR_ORGAO = "usuario-por-orgao";

const endpoint = "dominio-geral";

const getDominioAdicionandoInativo = async (dominio, inativo) => {
  try {
    const response = await http.get(`/${endpoint}/dominio?nome=${dominio}`);
    const data = response.data;

    // console.log('data', data);
    // console.log('inativo', inativo);

    // Se o inativo não for válido, retorna apenas os dados da API
    if (!inativo || !inativo.id || !inativo.nome) {
      console.log("não tem inativo. saindo...");
      return { data };
    }

    // Verifica se o inativo já está presente
    const jaExiste = data.some((item) => item.id === inativo.id);

    // Se não existe, adiciona o inativo com o label ajustado
    const novaLista = jaExiste
      ? data
      : [...data, { ...inativo, nome: `${inativo.nome} (inativo)` }];

    // console.log('novaLista', novaLista);
    return { data: novaLista };
  } catch (erro) {
    console.error("Erro ao buscar domínio:", erro);

    // Retorna somente o inativo, com o label ajustado, se for válido
    if (inativo && inativo.id && inativo.nome) {
      return {
        data: [{ ...inativo, nome: `${inativo.nome} (inativo)` }],
      };
    }

    return { data: [] };
  }
};

const getDominio = (dominio) => {
  return http.get(`/${endpoint}/dominio?nome=${dominio}`);
};

const encontrarListaPorNomeDominio = (listas = [], nomeDominio = "") => {
  return (listas || []).find((item) => item?.sigla === nomeDominio);
};

const isValorAtivo = (valorAtributo) => {
  if (typeof valorAtributo === "boolean") return valorAtributo;
  return ["true"].includes(valorAtributo);
};

const getDominioListaByNome = async (nomeDominio) => {
  const searchParams = new URLSearchParams({ sigla: nomeDominio }).toString();
  const response = await http.get(`/dominio-lista/buscar-por-sigla?${searchParams}`);
  const payload = response?.data;
  const listas = Array.isArray(payload) ? payload : [];
  const lista = encontrarListaPorNomeDominio(listas, nomeDominio) || null;

  if (!lista?.id) return null;

  const details = await http.get(`/dominio-lista/buscar/${lista.id}`);
  const dominioLista = details?.data;
  if (!dominioLista) return null;

  return {
    ...dominioLista,
    itens: montarMetadadosDominioGeral(dominioLista)
  };
};

const getDominioFiltradoPorMetadadoAtivo = async (dominio, nomeMetadado) => {
  
  const response = await getDominio(dominio);
  let itens = response?.data || [];
  const hasMetadados = itens.some((item) => (item?.metadadosDominioGeral || []).length > 0);

  if (!hasMetadados) {
    const dominioLista = await getDominioListaByNome(dominio);

    if (dominioLista?.itens?.length) {
      itens = dominioLista.itens;
    }
  }

  const data = itens.filter((item) =>
    (item?.metadadosDominioGeral || []).some((metadado) => {
      const nomeAtributo = metadado?.metadadoDominioLista?.nomeAtributo
      return nomeAtributo === nomeMetadado && isValorAtivo(metadado?.valorAtributo);
    })
  );

  return { ...response, data };
};

const getDominioSplitedLabel = async (dominio, index) => {
  const retorno = await getDominio(dominio).then((response) => {
    const dados = response.data.map((item) => ({ ...item, nome: item.nome.split("/")[index] }));
    return {...response, data: dados};
  });
  return retorno;
};

const getDominioFiltro = (dominio, filter) => {
  const queryParams = `&ativos=false&filter=${filter || ""}`;
  return http.get(`/${endpoint}/dominio-filtro?nome=${dominio}${queryParams}`);
};

const getDominioComInativos = async (dominio, filter, { incluirTodosInativos = false, inativoSelecionado } = {}) => {
  const response = await getDominioFiltro(dominio, filter);
  const data = response?.data || [];
  const idInativoSelecionado = inativoSelecionado?.id;

  return {
    ...response,
    data: data
      .filter((item) => {
        const ativo = item.status == null || item.status === "AT";
        return ativo || incluirTodosInativos || item.id === idInativoSelecionado;
      })
      .map((item) => {
        const ativo = item.status == null || item.status === "AT";
        if (ativo) return item;

        return {
          ...item,
          nome: `${item.nome} (inativo)`,
          ...(item.id === idInativoSelecionado && !incluirTodosInativos ? { readOnly: true } : {}),
        };
      }),
  };
};

const getDominioAtivosFiltro = (dominio, filter) => {
  const queryParams = filter
    ? `&ativos=true&filter=${filter || ""}`
    : "&ativos=true";
  return http.get(`/${endpoint}/dominio-filtro?nome=${dominio}${queryParams}`);
};

const getDominioPaginado = (dominio, filter, page, maxRows) => {
  const queryParams = `&ativos=false&filter=${
    filter || ""
  }&page=${page}&maxRows=${maxRows}`;
  return http.get(
    `/${endpoint}/dominio-filtro-paginado?nome=${dominio}${queryParams}`
  );
};

const getDominioAtivosPaginado = (dominio, filter, page, maxRows) => {
  const queryParams = `&ativos=true&filter=${
    filter || ""
  }&page=${page}&maxRows=${maxRows}`;
  return http.get(
    `/${endpoint}/dominio-filtro-paginado?nome=${dominio}${queryParams}`
  );
};

const getEntidadeDominio = (dominio, filter) => {
  const queryParams = filter ? `?filter=${filter || ""}` : "";
  return http.get(`/${endpoint}/${dominio}${queryParams}`);
};

const getEntidadeDominioPaginado = (dominio, filter, page, maxRows, params = {}) => {
  const queryParams = new URLSearchParams({ filter: filter || "", page, maxRows });
  Object.entries(params).forEach(([name, value]) => {
    if (value !== undefined && value !== null) {
      queryParams.set(name, value);
    }
  });
  return http.get(`/${endpoint}/${dominio}-paginado?${queryParams.toString()}`);
};

const getEntidadeDominioById = (dominio, ids) => {
  const queryParams = ids ? `?${new URLSearchParams({ ids }).toString()}` : "";
  return http.get(`/${endpoint}/${dominio}-by-ids${queryParams}`);
};

const getEntidadeDominioFilho = (dominio, idEntidadePai) => {
  return http.get(
    `/${endpoint}/${dominio}?idEntidadePai=${idEntidadePai || ""}`
  );
};

export function getNomeDominio(codigo, dominio, property = "nome") {
  const output = dominio.find((d) => d.codigo === codigo)?.[property] || "";
  return output;
}

export function getItemDominio({ dominio, codigo, id }) {
  if (dominio == null || (dominio == null && codigo == null)) return null;

  return id
    ? dominio.find((d) => d.id === id)
    : dominio.find((d) => d.codigo === codigo);
}

const getTiposDocumentosEnteExistentes = (codigoIbge) => {
  return http.get(`/${endpoint}/tipos-documentos-ente-existentes?codigoIbge=${codigoIbge}`).then(response => response.data);
}

const getTipoDocumentosPanoramaPaginado = (filter, page, maxRows) => {
  const queryParams = `&ativos=true&filter=${
    filter || ""
  }&page=${page}&maxRows=${maxRows}`;
  return http.get(
    `/${endpoint}/tipo-documentos-panorama-paginado?${queryParams}`
  );
};

export default {
  ...GenericHttpService(endpoint),
  getDominio,
  getDominioAdicionandoInativo,
  getDominioComInativos,
  getDominioFiltro,
  getDominioAtivosFiltro,
  getEntidadeDominio,
  getEntidadeDominioPaginado,
  getDominioPaginado,
  getDominioAtivosPaginado,
  getEntidadeDominioById,
  getEntidadeDominioFilho,
  getTiposDocumentosEnteExistentes,
  getDominioSplitedLabel,
  getDominioFiltradoPorMetadadoAtivo,
  getTipoDocumentosPanoramaPaginado,
};
